/**
 * @generated SignedSource<<5e4979f36846f3506a8b73fe6c9c9484>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Endpoint",
    "kind": "LinkedField",
    "name": "endpointById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contactsComponentsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contactsComponentsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "44cca4d7c47c12b5265255207b98bfa8",
    "id": null,
    "metadata": {},
    "name": "contactsComponentsQuery",
    "operationKind": "query",
    "text": "query contactsComponentsQuery(\n  $id: String\n) {\n  endpointById(id: $id) {\n    id\n    name\n  }\n}\n"
  }
};
})();

node.hash = "439082f09c2a59f7ca27c27b42899bcb";

module.exports = node;
